import { nanoid } from 'nanoid';
import type { Snippet, SupportedLanguage, SnippetTheme } from './snippet.types';

const STORAGE_PREFIX = 'famini_snippet_';

export const LANGUAGE_OPTIONS: { value: SupportedLanguage; label: string; prismId: string }[] = [
  { value: 'javascript', label: 'JavaScript', prismId: 'javascript' },
  { value: 'typescript', label: 'TypeScript', prismId: 'typescript' },
  { value: 'python', label: 'Python', prismId: 'python' },
  { value: 'css', label: 'CSS', prismId: 'css' },
  { value: 'html', label: 'HTML', prismId: 'markup' },
  { value: 'json', label: 'JSON', prismId: 'json' },
  { value: 'bash', label: 'Bash', prismId: 'bash' },
  { value: 'go', label: 'Go', prismId: 'go' },
  { value: 'rust', label: 'Rust', prismId: 'rust' },
  { value: 'java', label: 'Java', prismId: 'java' },
  { value: 'csharp', label: 'C#', prismId: 'csharp' },
  { value: 'markdown', label: 'Markdown', prismId: 'markdown' },
];

export const THEME_OPTIONS: { value: SnippetTheme; label: string; cssFile: string }[] = [
  { value: 'tomorrow', label: 'Tomorrow Night', cssFile: 'prism-tomorrow' },
  { value: 'nord', label: 'Nord', cssFile: 'prism-nord' },
  { value: 'dracula', label: 'Dracula', cssFile: 'prism-okaidia' },
];

export function generateSnippetId(): string {
  return nanoid(8);
}

export function saveSnippet(snippet: Snippet): void {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${snippet.id}`, JSON.stringify(snippet));
  } catch {
    // localStorage quota exceeded — silently fail
  }
}

export function loadSnippet(id: string): Snippet | null {
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${id}`);
    if (!raw) return null;
    return JSON.parse(raw) as Snippet;
  } catch {
    return null;
  }
}

export function buildShareUrl(id: string): string {
  const base = window.location.href.split('#')[0];
  return `${base}#snippet-${id}`;
}

export function parseSnippetIdFromHash(hash: string): string | null {
  const match = hash.match(/^#snippet-([A-Za-z0-9_-]{8})$/);
  return match ? match[1] : null;
}
